module.exports = __webpack_public_path__ + "static/media/retrato.6a56ab84.png";